/**
 * 获取query参数对象
 */
export default () => {
  const search = window.location.href.split('?')[1];
  if (!search) {
    return {};
  }

  return search.split('&').reduce((prev, curr) => {
    const p = curr.split('=');
    // eslint-disable-next-line no-param-reassign
    prev[decodeURIComponent(p[0])] = decodeURIComponent(p[1] || '');
    return prev;
  }, {});
};
